module.exports = __webpack_public_path__ + "img/schema 3 - DE.9f9f8c62.svg";